import { render, staticRenderFns } from "./Postback.vue?vue&type=template&id=41aad908"
import script from "./Postback.vue?vue&type=script&lang=js"
export * from "./Postback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports